<!-- Loader starts-->
<!-- <div class="loader-wrapper"[class.loderhide]="!show">
  <div class="loader-index"><span></span></div>
  <svg>
    <defs></defs>
    <filter id="goo">
      <fegaussianblur in="SourceGraphic" stddeviation="11" result="blur"></fegaussianblur>
      <fecolormatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"> </fecolormatrix>
    </filter>
  </svg>
</div> -->
<!-- Loader ends-->

<div class="loader-wrapper principal"[class.loderhide]="!show">
  <object class="img">
    <!-- <embed style="position: absolute;transform: translate(-50%,-320%);height: 15%" src="./assets/mingob/fondogob.svg"> -->
      <embed style="position: absolute;transform: translate(-50%,-320%);height: 15%" src="./assets/mingob/MinGob_Horizontal.png">
</object>

<object>
        <embed style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);height: 30%" src="./assets/mingob/principal.svg">
</object>
</div>
